<a class="catalog-home__link" ui-sref route="{{route}}">
    <div class="catalog-home__link-box">
        <div class="catalog-home__link-text">
            <span class="dku-small-title">{{title}}</span>
            <p class="catalog-home__link-description">{{description}}</p>
        </div>
        <img class="catalog-home__link-image" [src]="src">
    </div>
</a>
